var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"14","height":"14","x":"8","y":"8","rx":"2","ry":"2","key":0}),React.createElement("path",{"d":"M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2","key":1})]);
}

Copy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-copy-icon lucide-copy"};

module.exports = Copy;

Copy.default = Copy;
